import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  root: {
    // input label when focused
    '& label.Mui-focused': {
      color: '#3AB795',
    },

    // focused color for input with variant='standard'
    '& .MuiInput-underline:after': {
      borderBottomColor: '#3AB795',
    },
    // focused color for input with variant='filled'
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: '#3AB795',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3AB795',
    },
    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3AB795',
    },
    // focused color for input with variant='outlined'
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#3AB795',
      },
    },
  },
});
